import { LOAN_PRODUCT_TYPE } from 'apps/di-ld/src/app/core/constant/base.enum';
import loan_sm from 'assets/data/product-shelf-master/loan-smartmoney';

export default [
  // {
  //   campaignId: 'TLCMTNCSAX2104005',
  //   cifNo: '9779523',
  //   effectiveDate: '2021-07-21T21:05:02+07:00',
  //   expirationDate: '2021-07-28T21:05:02+07:00',
  //   maxCreditLimit: 1000000,
  //   maxInterestRate: 15,
  //   minCreditLimit: 5000,
  //   minInterestRate: 1,
  //   personalizedMessage: null,
  //   personalizedTitle: null,
  //   productType: LOAN_PRODUCT_TYPE.PAYDAY,
  //   productNameEn: 'Payday Loan',
  //   productNameTh: 'สินเชื่อกรุงไทยใจดี',
  // },
  // {
  //   campaignId: 'TLCMTNCSAX2104005',
  //   cifNo: '9779523',
  //   effectiveDate: '2021-07-21T21:05:02+07:00',
  //   expirationDate: '2021-07-28T21:05:02+07:00',
  //   maxCreditLimit: 500000,
  //   maxInterestRate: 11,
  //   minCreditLimit: 5000,
  //   minInterestRate: 1,
  //   personalizedMessage: null,
  //   personalizedTitle: null,
  //   productType: LOAN_PRODUCT_TYPE.THUNGNGERN,
  //   productNameEn: '100k Loan',
  //   productNameTh: 'สินเชื่อสิบหมื่น',
  // },
  loan_sm,
];
